/**
 * Datasets-view
 */
export const DatasetsView = (function () {

  var svg;

  var init =  function () {

    toggleAllOnLoad();

    $('.myds-open-dataset').on('click', (e) => {
      e.preventDefault();

      openCloseDatasetView(e.currentTarget);
    });

    $("input[class^='myds-permission-']").on('change', (e) => {
      let checkbox = $(e.target);
      let datasetCheckedTick = checkbox.closest('.myds-datasets').find('.myds-expand-view');
      let dataset = checkbox.closest('.table').attr('id').split('-')[2];
      let permission = checkbox.data('id').split('-')[1];
      let columnPermissionCheckboxes = $('#myds-table-' + dataset).find('.myds-permission-' + permission);
      let allPermissionCheckboxes = $('#myds-table-' + dataset).find('[class^="myds-permission-"]').filter(':checked').not('.myds-permission-mandatory');
      let mandatoryCheckbox = checkbox.parent().parent().parent().find('.myds-permission-mandatory');

      if(!checkbox.hasClass('myds-permission-mandatory')) {
        // if the permission is checked enable mandatory checkbox
        if(checkbox.is(':checked')) {
          mandatoryCheckbox.prop('disabled', false);
          datasetCheckedTick.removeClass('d-none');
          checkbox.closest('.myds-datasets').addClass('myds-selected');
        } else {
          // check if there are other checkboxes(permissions) ticked and if not disable and unchecked mandatory checkbox
          let rowActiveCheckboxes = $(checkbox).parent().parent().parent().find('[class^="myds-permission-"]').filter(':checked').not('.myds-permission-mandatory');
          if(rowActiveCheckboxes.length == 0) {
            mandatoryCheckbox.prop('checked', false);
            mandatoryCheckbox.prop('disabled', true);
          }
        }

        if(columnPermissionCheckboxes.length == columnPermissionCheckboxes.filter(':checked').length) {
          //if all individual checkboxes have been clicked it will toggle on the slide checkbox All for that permission
          $('#' + permission + '-' + dataset).prop("checked", true);
        } else {
          $('#' + permission + '-' + dataset).prop("checked", false);
        }

        if(allPermissionCheckboxes.length === 0) {
          //if no checkboxes are clicked it will disabled the slide checkbox for the dataset
          datasetCheckedTick.addClass('d-none');
          checkbox.closest('.myds-datasets').removeClass('myds-selected');
          //if no checkboxes are clicked disable and untick all mandatory checkboxes
          $('#myds-table-' + dataset).find('.myds-permission-mandatory').prop('checked', false);
          $('#myds-table-' + dataset).find('.myds-permission-mandatory').prop('disabled', true);
        }

      }
           
    });
    // toggle checkboxes All (read, update, create, delete)
    $("input[class^='myds-all-']").on('change', function(e) {
      toggleCheckboxes(e.target);
    });
    //search datasets by name
    $('#myds-search-dataset').on('keyup search', function() {
      var searchValue = $(this).val().toLowerCase();
      $('.myds-datasets').addClass('d-none');
      
      if(searchValue == '') {
        $('.myds-selected').removeClass('d-none');

        $('.myds-selected').each(function(i, el) {
          let button = $(el).find('.myds-open-dataset');

          openCloseDatasetView(button, true)
        })

        return;
      }

      $(".myds-dataset-font").filter(function() {
        var row = $(this).parent().closest('.myds-datasets');
        var datasetName = $(this).text().toLowerCase()

        if(datasetName.indexOf(searchValue) > -1) {
          row.removeClass('d-none');
        }
      });
    });

  }

  var openCloseDatasetView = function(element, search) {
    var idClass = $(element).attr('id');
    svg = $(element).find('svg');

    if(search) {
      svg.removeClass('fa-minus');
      svg.addClass('fa-plus');
      $('.' + idClass).addClass('d-none');
    } else {
      svg.toggleClass('fa-minus');
      svg.toggleClass('fa-plus');
      $('.' + idClass).toggleClass('d-none');
      let checked = svg.closest('.myds-datasets').hasClass('myds-selected');

      if(svg.hasClass('fa-plus') && !checked) {
        svg.closest('.myds-datasets').addClass('d-none');
      }
    }
  }

  var toggleCheckboxes = function(input, singleCheckbox) {
    var element = $(input).attr('id').split('-');
    var dataset = element[1];
    var classCheckbox = element[0];
    var datasetTick = $(input).closest('.myds-datasets').find('.myds-expand-view');
    var mandatoryCheckboxes = $('#myds-table-' + dataset).find('.myds-permission-mandatory');
    var currentActiveCheckboxes = $('#myds-table-' + dataset).find('.myds-permission-' + classCheckbox);
    var currentMandatory;
    var crudCheckboxes;

    if($(input).is(':checked')){
      // display tick icon
      datasetTick.removeClass('d-none');
      $(input).closest('.myds-datasets').addClass('myds-selected');
      //check all checkboxes for that permission
      $('#myds-table-' + dataset).find('.myds-permission-' + classCheckbox).prop("checked", true);
      //enable mandatory checkboxes
      mandatoryCheckboxes.prop('disabled', false);
    } else {
      //uncheck all checkboxes for that permission
      currentActiveCheckboxes.prop("checked", false);
      
      $.each(currentActiveCheckboxes, function(i, el) {
        crudCheckboxes = $(el).closest('tr').find('[class^="myds-permission-"]').filter(':checked').not('.myds-permission-mandatory');
        currentMandatory = $(el).closest('tr').find('.myds-permission-mandatory');

        if(crudCheckboxes.length == 0) {
          $(currentMandatory).prop('disabled', true);
          $(currentMandatory).prop('checked', false);
        }
      });
      
    }
    let allFieldsCheckboxes = $('#myds-table-' + dataset).find('[class^="myds-permission-"]').filter(':checked');
    
    if(allFieldsCheckboxes.length == 0) {
      datasetTick.addClass('d-none');
      $(input).closest('.myds-datasets').removeClass('myds-selected');
    }

  }

  var toggleAllOnLoad = function() {
    $('.myds-open-dataset').each(function(i,el){
      let dataset = $(el).attr('id');
      let permissions = $('#myds-' + dataset).find('.myds-mark-toggle');

      $(permissions).each(function() {
        let permission = $(this).attr('id').split('-')[0];
        let fieldsPermissions = $('.table-' + dataset).find('.myds-permission-' + permission);
        if(fieldsPermissions.not(':checked').length == 0) {
          $(this).prop('checked', true);
          $('input[name="selected[' + dataset + ']"]').prop('checked', true);
        }
      });

      });
  }

  return {
    init: init
  }

}());


